<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>课程分类</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="编号:" prop="code">
                          <el-input
                            id="code"
                            v-model="SelectData.code"
                            clearable
                            :disabled="true"
                          />
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="分类名称:" prop="name">
                          <el-input
                            id="name"
                            v-model="SelectData.name"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="分类级别:" prop="levlel">
                          <el-input
                            id="levlel"
                            v-model="SelectData.levlel"
                            clearable
                            :disabled="true"
                          />
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="是否子分类:" prop="isLeaf">
                          <el-switch
                            id="isLeaf"
                            v-model="SelectData.isLeaf"
                            size="large"
                            active-text="是"
                            inactive-text="否"
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6" v-show="SelectData.parentId!=0">
                      <div class="grid-content bg-purple">
                        <el-form-item label="优先级:" prop="levelNumber">
                          <el-input
                            id="levelNumber"
                            v-model="SelectData.levelNumber"
                            clearable
                            type="number"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  SelectCourseCategoryById,
  ModifyCourseCategory,
  AddCourseCategory,
} from "@api/ApiCourseCategory";
export default {
  name: "CourseCategoryEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
    };
  },
  created() {},
  mounted() {},
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(row, type) {
      //debugger;
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.SelectData={};

      //增加子节点
      if (type == "Add") {
        _this.IsReadonlyCode = false;

        _this.SelectData.isLeaf=true;
        _this.SelectData.levlel=row.levlel+1;
        _this.SelectData.parentId=row.id;

        return
      }
       //增加根节点
      if (type == "AddParent") {
        _this.IsReadonlyCode = false;

        _this.SelectData.isLeaf=false;
        _this.SelectData.levlel=1;
        _this.SelectData.parentId=0;

        return
      }
      _this.SelectData = row;

    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if(!this.validate())return;
      if (_this.OpStatus == "Add"||_this.OpStatus == "AddParent") {
        let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"))
        this.SelectData.creatorName= USER_INFO.UserName
        this.SelectData.companyId= USER_INFO.CompanyId
        AddCourseCategory(_this.SelectData)
        .then(function (data) {
          _this.$message.success("新增成功!");
          _this.$emit("handle-confirm");
        }).catch(res=>{
          _this.$message.error(res.message);
        });
      } else if (_this.OpStatus == "Modify") {
        ModifyCourseCategory(_this.SelectData)
        .then(function (data) {
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        }).catch(res=>{
          _this.$message.error(res.message);
        });
      }
    },
    validate() {
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("分类名称是必须的!");
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
